import axios from 'axios';

export const state = {
}

export const getters = {}

export const mutations = {
}

export const actions = {

  async orderReports({ commit, dispatch, getters }, pagination = {}) {

    const { where, page, rowsPerPage, sortBy, descending } = pagination;

    const result = await axios.post('order-report/list',
      {
        where: where || null,
        search: null,
        strict: true,
        pagination: {
          page,
          rowsPerPage,
          sortBy,
          descending
        }
      });

    return result.data;
  },

  async ledger({ commit, dispatch, getters }, pagination = {}) {

    const { page, rowsPerPage, sortBy, descending } = pagination;

    const result = await axios.post('ledger/list',
      {
        where: null,
        search: null,
        strict: true,
        pagination: {
          page,
          rowsPerPage,
          sortBy,
          descending
        }
      });

    return result.data;
  },
}
